import React, { useEffect } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

const GoogleCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    
    if (code) {
      // Close this window and pass the code back to the opener window
      if (window.opener) {
        window.opener.postMessage({ type: 'GOOGLE_AUTH_CODE', code }, window.location.origin);
        window.close();
      } else {
        // If no opener, navigate back to settings
        navigate('/settings');
      }
    } else {
      // Handle error
      navigate('/settings');
    }
  }, [location, navigate]);

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100vh' 
    }}>
      <CircularProgress sx={{ mb: 2 }} />
      <Typography variant="h6">
        Processing Google authorization...
      </Typography>
    </Box>
  );
};

export default GoogleCallback; 